'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledSystem = require('styled-system');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var tag = _react2.default.forwardRef(function (_ref, ref) {
  var _ref$is = _ref.is,
      Component = _ref$is === undefined ? 'div' : _ref$is,
      width = _ref.width,
      color = _ref.color,
      bg = _ref.bg,
      m = _ref.m,
      mt = _ref.mt,
      mr = _ref.mr,
      mb = _ref.mb,
      ml = _ref.ml,
      mx = _ref.mx,
      my = _ref.my,
      p = _ref.p,
      pt = _ref.pt,
      pr = _ref.pr,
      pb = _ref.pb,
      pl = _ref.pl,
      px = _ref.px,
      py = _ref.py,
      fontSize = _ref.fontSize,
      css = _ref.css,
      props = _objectWithoutProperties(_ref, ['is', 'width', 'color', 'bg', 'm', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'fontSize', 'css']);

  return _react2.default.createElement(Component, _extends({}, props, {
    ref: ref
  }));
});

var Box = (0, _styledComponents2.default)(tag)([], _styledSystem.color, _styledSystem.space, _styledSystem.fontSize, _styledSystem.width, function (props) {
  return props.css;
});
Box.displayName = 'Box';
Box.propTypes = _extends({}, _styledSystem.color.propTypes, _styledSystem.space.propTypes, _styledSystem.fontSize.propTypes, _styledSystem.width.propTypes, {
  css: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
});
exports.default = Box;